var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function serviceOptions($rootScope, $http, cmdiOptions, $compile) {
        return {
            transclude: true,
            link: function (scope, tElement, tAttrs, uploadElemenetCtrl) {
                var serviceName = tAttrs.operationname;
                var templatePromise = cmdiOptions.getOptionsForServiceName(serviceName);
                var optionalHint = "";
                if (tAttrs.optionalhint != undefined) {
                    optionalHint += "<br/>";
                    optionalHint += "<div>";
                    optionalHint += tAttrs.optionalhint;
                    optionalHint += "</div>";
                }
                templatePromise.then(function (data) {
                    data = '<div> \
                                <div class="service-options"> \
                                    <div class="serviceOptionContainer">' + data + '</div>\
                                    <div class="serviceOptionContainer">' + optionalHint + '</div>\
                                 </div>\
                            </div>';
                    tElement.append(data);
                    $compile(tElement.contents())(scope);
                });
            },
        };
    }
    BASWebServices.serviceOptions = serviceOptions;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=serviceOptions.js.map